module.exports = __webpack_public_path__ + "static/img/help.267d0c8b.png";